import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export const createLoaderSelector = <
  TState extends Record<string, any> & { loading: Record<string, boolean> }
>(
  stateSelector: (state: RootState) => TState,
  loaderKey: keyof TState['loading']
) =>
  createSelector(
    stateSelector,
    (state) => state.loading[loaderKey] as boolean
  );
